<template>
    <div class='page'>
        <div class="center success_wrap"><img class="success" src="https://o-yzx.bysjy.com.cn/frontend/mergres.png" alt=""></div>

        <div class="center tips_1">账号已合并，并已绑定成功</div>
        <div class="center tips_2">您可以正常访问平台页面</div>
        <div class="center affirm">
          <van-button color="#3399FF"  round style="width: 156px" @click="gotoSource">确 认</van-button>
        </div>

    </div>
</template>
<script>
import {Image as VanImage,Button} from 'vant';
import env from '@/utils/env'


export default {
        name: "mergres",
        components:{
           [Button.name]:Button,
        },
        data(){
            return {
                checked: false,
            }
        },
        mounted() {
          // 让用户进行刷新一次
          // this.util.server.mini_user.info({
          // callback: (res => {
          //       util.globalData.user.set(res.data);
          //       util.getUserId.set(res.data.user_id);
          //       util.user_mobile.set(res.data.mobile);
          //   })
          // })
        },
        methods:{
          gotoSource(){
            if(this.util.tempRedirect.get(location.href)){
              window.location = this.util.tempRedirect.get(location.href)
            }else{
              this.$router.replace(this.util.urlPrefix+'/home/index?'+'&token='+this.util.token)
            }
          },
        }
    }

</script>

<style scoped>

.page {
  padding: 10px 15px;
  background-color: #FFFFFF;
  height: 100vh;
  box-sizing: border-box;
}
.center{
  text-align: center;
}
.affirm{
  margin-top: 35px;
}
.tips_1{
  height: 18px;
  font-size: 14px;
  color: #4E4E4E;
}
.tips_2{
  height: 18px;
  font-size: 14px;
  color: #4E4E4E;
  margin-top: 5px;
}
.success{
  width: 110px;
}
.success_wrap{
  margin-top: 65px;
}
</style>